export const THEME_KEY = "thoth_theme";
export const THEMES = ["default", "scuro", "chiaro", "auto"];
export const AUTO_DAY_START = 7;
export const AUTO_DAY_END = 21;

export function getTheme() {
  const t = localStorage.getItem(THEME_KEY);
  return THEMES.includes(t) ? t : "default";
}

// Automatico: Chiaro dalle 07:00 alle 21:00, Default (blu notte) il resto.
export function resolveTheme(t, now = new Date()) {
  if (t !== "auto") return t;
  const h = now.getHours();
  return h >= AUTO_DAY_START && h < AUTO_DAY_END ? "chiaro" : "default";
}

export function applyTheme(t) {
  const theme = THEMES.includes(t) ? t : "default";
  const eff = resolveTheme(theme);
  if (document.documentElement.getAttribute("data-theme") !== eff) document.documentElement.setAttribute("data-theme", eff);
}

export function setTheme(t) {
  const theme = THEMES.includes(t) ? t : "default";
  localStorage.setItem(THEME_KEY, theme);
  applyTheme(theme);
}

// Ricontrolla ogni minuto (e al ritorno sulla finestra) per il cambio automatico giorno/notte.
export function startAutoTheme() {
  const tick = () => { if (getTheme() === "auto") applyTheme("auto"); };
  setInterval(tick, 60000);
  document.addEventListener("visibilitychange", tick);
}
